(function () {
  'use strict';

  var STORAGE_KEY = 'quotecart_items';
  var PROXY_URL = 'https://crm-relay.torchstar.us/api/inquiry';
  var BODY_CLASS = 'quote-sidebar-show';

  // ── State ─────────────────────────────────────────────
  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateUI();
  }

  function addItem(item) {
    var items = getItems();
    var key = item.product_handle + ':' + (item.variant_id || '');
    var existing = items.findIndex(function (i) {
      return (i.product_handle + ':' + (i.variant_id || '')) === key;
    });
    if (existing >= 0) {
      items[existing].quantity = (items[existing].quantity || 1) + (item.quantity || 1);
    } else {
      items.push(item);
    }
    saveItems(items);
    return existing >= 0 ? 'updated' : 'added';
  }

  function removeItem(index) {
    var items = getItems();
    items.splice(index, 1);
    saveItems(items);
  }

  function updateQuantity(index, qty) {
    var items = getItems();
    if (items[index]) {
      items[index].quantity = Math.max(1, qty);
      saveItems(items);
    }
  }

  function clearAll() {
    saveItems([]);
  }

  // ── UI updates ────────────────────────────────────────
  function updateUI() {
    var items = getItems();
    var count = items.length;

    // Header badges
    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      var textEl = el.querySelector('.text') || el;
      if (count > 0) {
        textEl.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    // Sidebar count text
    var countText = document.querySelector('[data-quote-count-text]');
    var countLabel = document.querySelector('[data-quote-count-label]');
    if (countText) countText.textContent = count;
    if (countLabel) countLabel.textContent = count === 1 ? 'item' : 'items';

    // Toggle empty message / product list (form is always visible)
    var emptyEl = document.getElementById('quoteDrawerEmpty');
    var contentEl = document.getElementById('quoteDrawerContent');
    if (emptyEl) emptyEl.style.display = count === 0 ? '' : 'none';
    if (contentEl) contentEl.style.display = count > 0 ? '' : 'none';

    // Update submit button text based on whether there are products
    var submitText = document.querySelector('.qc-form-submit-text');
    if (submitText) {
      submitText.textContent = count > 0 ? 'Submit Quote Request' : 'Submit Inquiry';
    }

    // Update Add to Quote button text based on cart state
    document.querySelectorAll('.quote-add-trigger').forEach(function (btn) {
      if (btn.classList.contains('is-added')) return; // don't change during "Added ✓" feedback
      if (btn.getAttribute('data-pdp') === 'true') {
        btn.textContent = 'Request a Quote';
        return;
      }
      btn.textContent = count > 0 ? 'Add to Quote' : 'Request a Quote';
    });

    // Render items
    renderItems(items);
  }

  function renderItems(items) {
    var container = document.getElementById('quoteDrawerItems');
    if (!container) return;
    var showPrice = window.__quoteShowPrice;

    var grandTotal = 0;
    var html = '<table class="qc-table"><thead><tr>' +
      '<th class="qc-th-img"></th>' +
      '<th class="qc-th-product">Product</th>' +
      '<th class="qc-th-qty">Qty</th>' +
      '<th class="qc-th-target">Target $</th>' +
      '<th class="qc-th-sub">Subtotal</th>' +
      '<th class="qc-th-del"></th>' +
      '</tr></thead><tbody>';

    items.forEach(function (item, idx) {
      var pTitle = item.product_title || 'Product';
      var qty = item.quantity || 1;
      var offerPrice = item.offer_price || '';
      var subtotal = offerPrice ? (parseFloat(offerPrice) * qty) : 0;
      if (subtotal) grandTotal += subtotal;
      var variantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var skuText = item.variant_sku ? 'SKU: ' + item.variant_sku : '';
      var meta = [variantText, skuText].filter(Boolean).join(' | ');

      html +=
        '<tr class="qc-row" data-qc-index="' + idx + '">' +
          '<td class="qc-td-img">' +
            (item.product_image ? '<img src="' + item.product_image + '" alt="" width="40" height="40" />' : '') +
          '</td>' +
          '<td class="qc-td-product">' +
            '<div class="qc-product-name-wrap"><div class="qc-product-name-scroll"><a href="/products/' + escHtml(item.product_handle || '') + '">' + escHtml(pTitle) + '</a></div></div>' +
            (meta ? '<div class="qc-product-meta">' + escHtml(meta) + '</div>' : '') +
            (showPrice && item.variant_price ? '<div class="qc-product-meta">' + escHtml(item.variant_price) + '</div>' : '') +
          '</td>' +
          '<td class="qc-td-qty"><input class="qc-input-sm" type="number" value="' + qty + '" min="1" data-qc-qty-input="' + idx + '" /></td>' +
          '<td class="qc-td-target"><input class="qc-input-sm" type="number" value="' + offerPrice + '" min="0" step="0.01" placeholder="0" data-qc-offer="' + idx + '" /></td>' +
          '<td class="qc-td-sub">' + (subtotal ? '$' + subtotal.toFixed(2) : '-') + '</td>' +
          '<td class="qc-td-del"><a href="#" data-qc-remove="' + idx + '" title="Remove">&times;</a></td>' +
        '</tr>';
    });

    html += '</tbody></table>';
    container.innerHTML = html;

    // Update header total
    var totalEl = document.getElementById('quoteDrawerTotal');
    var totalValEl = document.getElementById('quoteDrawerTotalValue');
    var clearBtn = document.getElementById('quoteDrawerClearBtn');
    if (totalEl && totalValEl) {
      if (grandTotal > 0) { totalValEl.textContent = '$' + grandTotal.toFixed(2); totalEl.style.display = ''; }
      else { totalEl.style.display = 'none'; }
    }
    if (clearBtn) clearBtn.style.display = items.length > 0 ? '' : 'none';
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  // ── Inject floating icon into recently-viewed toolbar ──
  function injectFloatingIcon() {
    var wrap = document.getElementById('halo-recently-viewed-wrap');
    if (!wrap) return;
    if (wrap.querySelector('.qc-floating-icon')) return; // already injected

    var el = document.createElement('div');
    el.className = 'recently-viewed-icon qc-floating-icon';
    el.setAttribute('data-quote-cart-toggle', '');
    el.setAttribute('role', 'button');
    el.setAttribute('aria-label', 'Quote List');
    el.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#4c4b4b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-quote-cart">' +
        '<path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/>' +
        '<rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>' +
        '<line x1="9" y1="12" x2="15" y2="12"/>' +
        '<line x1="9" y1="16" x2="13" y2="16"/>' +
      '</svg>' +
      '<span class="qc-floating-badge" data-quote-count style="display:none;">' +
        '<span class="text">0</span>' +
      '</span>';

    // Insert as first icon in the toolbar
    wrap.insertBefore(el, wrap.firstChild);
  }

  // ── Drawer open / close (body class toggle, same as cart) ──
  function openDrawer() {
    updateUI();
    document.body.classList.add(BODY_CLASS);
  }

  function closeDrawer() {
    document.body.classList.remove(BODY_CLASS);
  }

  // ── Handle "Add to Quote" from product card ───────────
  function handleAddToQuote(trigger) {
    var title = trigger.getAttribute('data-product-title') || '';
    var handle = trigger.getAttribute('data-product-handle') || '';
    var image = trigger.getAttribute('data-product-image') || '';
    var variantTitle = '', variantSku = '', variantPrice = '', variantId = '';
    var productId = '', variantPriceNum = 0, vendor = '';

    var card = trigger.closest('.product-item');
    if (card) {
      // Always parse product JSON first
      var pd = null;
      try {
        var jsonStr = card.getAttribute('data-json-product');
        if (jsonStr) pd = JSON.parse(jsonStr);
      } catch (e) { /* ignore */ }

      if (pd) {
        productId = pd.id ? String(pd.id) : '';
      }

      // Try to get currently selected variant ID
      // 1) From card-08 multi-option pills (collection page)
      var optionGroups = card.querySelectorAll('[data-card08-option]');
      if (optionGroups.length > 0) {
        var selectedOpts = [];
        optionGroups.forEach(function (group) {
          var active = group.querySelector('[data-card08-pill].is-active');
          if (active) selectedOpts.push(active.getAttribute('data-option-value'));
        });
        // Find matching variant by option combination
        if (pd && pd.variants) {
          var matched = pd.variants.find(function (v) {
            return v.options && v.options.every(function (opt, i) { return selectedOpts[i] === opt; });
          });
          if (matched) {
            variantId = String(matched.id);
            variantSku = matched.sku || '';
            variantPriceNum = matched.price || 0;
            variantPrice = variantPriceNum ? '$' + (variantPriceNum / 100).toFixed(2) : '';
            if (matched.title && matched.title !== 'Default Title') variantTitle = matched.title;
          }
        }
        // Fallback: read from card's hidden variant ID input (maintained by card's inline JS)
        if (!variantId) {
          var variantInput = card.querySelector('.card-08-variant-id');
          if (variantInput && variantInput.value) {
            variantId = variantInput.value;
            if (pd && pd.variants) {
              var fb = pd.variants.find(function (v) { return String(v.id) === variantId; });
              if (fb) {
                variantSku = fb.sku || '';
                variantPriceNum = fb.price || 0;
                variantPrice = variantPriceNum ? '$' + (variantPriceNum / 100).toFixed(2) : '';
                if (fb.title && fb.title !== 'Default Title') variantTitle = fb.title;
              }
            }
          }
        }
      }

      // 2) From product page form (PDP) — read selected variant from the ATC form
      if (!variantId && trigger.getAttribute('data-pdp') === 'true') {
        var pdpForm = document.querySelector('form[action="/cart/add"] select[name="id"], form[action="/cart/add"] input[name="id"]');
        if (pdpForm) variantId = pdpForm.value || '';
        if (!variantId) {
          var urlParams = new URLSearchParams(window.location.search);
          variantId = urlParams.get('variant') || '';
        }
      }

      // Look up variant data from product JSON (for PDP or fallback)
      if (pd && pd.variants && pd.variants.length > 0 && !variantSku) {
        var v = null;
        if (variantId) {
          v = pd.variants.find(function (x) { return String(x.id) === String(variantId); });
        }
        if (!v) {
          v = pd.variants[0];
          variantId = v.id ? String(v.id) : '';
        }
        if (v) {
          variantSku = v.sku || '';
          variantPriceNum = v.price || 0;
          variantPrice = variantPriceNum ? '$' + (variantPriceNum / 100).toFixed(2) : '';
          if (v.title && v.title !== 'Default Title') variantTitle = v.title;
        }
      }

      // Fallback: read price from DOM
      if (!variantPrice) {
        var priceEl = card.querySelector('.card-price .money') || document.querySelector('.product__price .money');
        if (priceEl) variantPrice = priceEl.textContent.trim();
      }

      // Get vendor
      var vendorEl = card.querySelector('.card-vendor a');
      if (vendorEl) vendor = vendorEl.textContent.trim();
    }

    var result = addItem({
      product_title: title,
      product_handle: handle,
      product_image: image,
      product_id: productId,
      vendor: vendor,
      variant_title: variantTitle,
      variant_sku: variantSku,
      variant_price: variantPrice,
      variant_price_cents: variantPriceNum,
      variant_id: variantId,
      quantity: 1,
    });

    // Button feedback
    var origText = trigger.textContent;
    trigger.textContent = result === 'updated' ? 'Updated \u2713' : 'Added \u2713';
    trigger.classList.add('is-added');
    setTimeout(function () {
      trigger.textContent = origText;
      trigger.classList.remove('is-added');
    }, 1500);

    // Animate: try fly-to-icon, always pulse as fallback
    try { flyToQuoteIcon(trigger, image); } catch (e) { /* ignore */ }
    var floatIcon = document.querySelector('.qc-floating-icon');
    if (floatIcon) {
      floatIcon.classList.remove('qc-pulse');
      void floatIcon.offsetWidth;
      floatIcon.classList.add('qc-pulse');
      setTimeout(function () { floatIcon.classList.remove('qc-pulse'); }, 800);
    }
  }

  // ── Fly-to-cart + pulse animation ───────────────────────
  function flyToQuoteIcon(trigger, imageSrc) {
    var target = document.querySelector('.qc-floating-icon');
    if (!target) return;

    var btnRect = trigger.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var dx = (targetRect.left + targetRect.width / 2) - (btnRect.left + btnRect.width / 2);
    var dy = (targetRect.top + targetRect.height / 2) - (btnRect.top + btnRect.height / 2);

    // Create ghost WITHOUT any transform or transition (avoids stacking context trap)
    var ghost = document.createElement('div');
    ghost.style.cssText =
      'position:fixed;z-index:2147483647;pointer-events:none;border-radius:6px;' +
      'width:50px;height:50px;' +
      'background:' + (imageSrc ? 'url(' + imageSrc + ') center/cover no-repeat' : '#ccc') + ';' +
      'box-shadow:0 4px 12px rgba(0,0,0,0.25);' +
      'left:' + (btnRect.left + btnRect.width / 2 - 25) + 'px;' +
      'top:' + (btnRect.top + btnRect.height / 2 - 25) + 'px;';

    var parent = document.getElementById('MainContent') || document.documentElement;
    parent.appendChild(ghost);

    // Web Animations API — runs on compositor, no CSS stacking context issues
    ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.15)', opacity: 0 }
    ], {
      duration: 550,
      easing: 'cubic-bezier(0.2, 0.8, 0.3, 1)',
      fill: 'forwards'
    });

    setTimeout(function () {
      ghost.remove();
      // Pulse the floating icon
      target.classList.add('qc-pulse');
      setTimeout(function () { target.classList.remove('qc-pulse'); }, 800);
    }, 580);
  }

  // ── Form submission ───────────────────────────────────
  function handleFormSubmit(e) {
    e.preventDefault();
    var form = e.target;

    var hp = form.querySelector('[name="hp_email"]');
    if (hp && hp.value) return;

    var emailInput = form.querySelector('[name="email"]');
    var firstInput = form.querySelector('[name="first_name"]');
    var lastInput = form.querySelector('[name="last_name"]');
    var errorEl = document.getElementById('quoteDrawerError');

    form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });
    if (errorEl) errorEl.style.display = 'none';

    var errors = [];
    if (!firstInput.value.trim()) { firstInput.classList.add('is-invalid'); errors.push('First name required'); }
    if (!lastInput.value.trim()) { lastInput.classList.add('is-invalid'); errors.push('Last name required'); }
    if (!emailInput.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value)) {
      emailInput.classList.add('is-invalid'); errors.push('Valid email required');
    }
    if (errors.length) {
      if (errorEl) { errorEl.textContent = errors[0]; errorEl.style.display = ''; }
      return;
    }

    var items = getItems();
    var products = items.map(function (item) {
      return {
        title: item.product_title,
        variant_title: item.variant_title,
        sku: item.variant_sku,
        handle: item.product_handle,
        image: item.product_image,
        price: item.variant_price,
        price_cents: item.variant_price_cents || 0,
        product_id: item.product_id || '',
        variant_id: item.variant_id || '',
        vendor: item.vendor || '',
        quantity: item.quantity || 1,
        offer_price: item.offer_price || null,
      };
    });

    var payload = {
      customer: {
        first_name: firstInput.value.trim(),
        last_name: lastInput.value.trim(),
        email: emailInput.value.trim(),
        phone: (form.querySelector('[name="phone"]') || {}).value || '',
        company: (form.querySelector('[name="company"]') || {}).value || '',
        message: (form.querySelector('[name="message"]') || {}).value || '',
      },
      products: products,
      source: products.length ? 'quote_cart' : 'general',
      hp_email: '',
    };

    var btn = form.querySelector('.qc-form-submit');
    btn.disabled = true;
    btn.querySelector('.qc-form-submit-text').style.display = 'none';
    btn.querySelector('.qc-form-submit-loading').style.display = '';

    fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (resp) {
        if (resp.ok) return resp.json();
        return resp.json().then(function (d) { throw new Error(d.message || 'Submission failed'); });
      })
      .then(function () {
        clearAll();
        form.reset();
        document.getElementById('quoteDrawerSuccess').style.display = '';
        var wrapper = document.querySelector('#halo-quote-sidebar .halo-sidebar-wrapper');
        if (wrapper) wrapper.style.display = 'none';
        setTimeout(function () {
          closeDrawer();
          setTimeout(function () {
            document.getElementById('quoteDrawerSuccess').style.display = 'none';
            if (wrapper) wrapper.style.display = '';
            btn.disabled = false;
            btn.querySelector('.qc-form-submit-text').style.display = '';
            btn.querySelector('.qc-form-submit-loading').style.display = 'none';
            updateUI();
          }, 500);
        }, 2500);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || 'Failed to submit.'; errorEl.style.display = ''; }
        btn.disabled = false;
        btn.querySelector('.qc-form-submit-text').style.display = '';
        btn.querySelector('.qc-form-submit-loading').style.display = 'none';
      });
  }

  // ── Events ────────────────────────────────────────────
  function bindEvents() {
    document.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('.quote-add-trigger'))) {
        e.preventDefault();
        handleAddToQuote(t);
        return;
      }
      if (e.target.closest('[data-quote-cart-toggle]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-quote-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      // Close on overlay click
      if (e.target.closest('.halo-quote-sidebar .qc-drawer__overlay') ||
          (document.body.classList.contains(BODY_CLASS) && e.target.classList.contains('background-overlay'))) {
        closeDrawer();
        return;
      }
      if ((t = e.target.closest('[data-qc-remove]'))) {
        removeItem(parseInt(t.getAttribute('data-qc-remove'), 10));
        return;
      }
      if ((t = e.target.closest('[data-qc-qty-minus]'))) {
        var idx = parseInt(t.getAttribute('data-qc-qty-minus'), 10);
        var items = getItems();
        if (items[idx]) updateQuantity(idx, (items[idx].quantity || 1) - 1);
        return;
      }
      if ((t = e.target.closest('[data-qc-qty-plus]'))) {
        var idx2 = parseInt(t.getAttribute('data-qc-qty-plus'), 10);
        var items2 = getItems();
        if (items2[idx2]) updateQuantity(idx2, (items2[idx2].quantity || 1) + 1);
        return;
      }
      if (e.target.closest('[data-qc-clear-all]')) {
        clearAll();
        return;
      }
    });

    document.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-qc-qty-input]');
      if (inp) updateQuantity(parseInt(inp.getAttribute('data-qc-qty-input'), 10), parseInt(inp.value, 10) || 1);

      var offerInp = e.target.closest('[data-qc-offer]');
      if (offerInp) {
        var oi = parseInt(offerInp.getAttribute('data-qc-offer'), 10);
        var items = getItems();
        if (items[oi]) {
          items[oi].offer_price = parseFloat(offerInp.value) || 0;
          saveItems(items);
        }
      }
    });

    var form = document.getElementById('quoteDrawerFormEl');
    if (form) form.addEventListener('submit', handleFormSubmit);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains(BODY_CLASS)) closeDrawer();
    });

    // Close via shared background-overlay click (used by all halo sidebars)
    var bgOverlay = document.querySelector('.background-overlay');
    if (bgOverlay) {
      bgOverlay.addEventListener('click', function () {
        if (document.body.classList.contains(BODY_CLASS)) closeDrawer();
      });
    }
  }

  // ── Hijack "Get Quote" links to open drawer instead ───
  function hijackQuoteLinks() {
    document.querySelectorAll('a[href*="/pages/contact"]').forEach(function (a) {
      var text = (a.textContent || '').trim().toLowerCase();
      if (text.includes('quote') || text.includes('get quote')) {
        a.setAttribute('data-quote-cart-toggle', '');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          openDrawer();
        });
      }
    });
  }

  // ── Init ──────────────────────────────────────────────
  function init() {
    injectFloatingIcon();
    hijackQuoteLinks();
    updateUI();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
